'use strict';

var cov_uzk6x96ju = function () {
    var path = '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.projects.factory.js',
        hash = 'c5c5955388ee00c896d3e58e4dd11c07350578f3',
        Function = function () {}.constructor,
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/taskatone-app/src/app/shared/js/ORM/tables.projects.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 60,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 11,
                    column: 8
                },
                end: {
                    line: 58,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 48,
                    column: 30
                },
                end: {
                    line: 48,
                    column: 40
                }
            },
            '4': {
                start: {
                    line: 49,
                    column: 20
                },
                end: {
                    line: 49,
                    column: 31
                }
            },
            '5': {
                start: {
                    line: 54,
                    column: 30
                },
                end: {
                    line: 54,
                    column: 40
                }
            },
            '6': {
                start: {
                    line: 55,
                    column: 20
                },
                end: {
                    line: 55,
                    column: 31
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 60,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 38
                    },
                    end: {
                        line: 59,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 47,
                        column: 24
                    },
                    end: {
                        line: 47,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 47,
                        column: 41
                    },
                    end: {
                        line: 50,
                        column: 17
                    }
                },
                line: 47
            },
            '3': {
                name: '(anonymous_3)',
                decl: {
                    start: {
                        line: 53,
                        column: 24
                    },
                    end: {
                        line: 53,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 53,
                        column: 41
                    },
                    end: {
                        line: 56,
                        column: 17
                    }
                },
                line: 53
            }
        },
        branchMap: {
            '0': {
                loc: {
                    start: {
                        line: 48,
                        column: 30
                    },
                    end: {
                        line: 48,
                        column: 40
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 48,
                        column: 30
                    },
                    end: {
                        line: 48,
                        column: 35
                    }
                }, {
                    start: {
                        line: 48,
                        column: 39
                    },
                    end: {
                        line: 48,
                        column: 40
                    }
                }],
                line: 48
            },
            '1': {
                loc: {
                    start: {
                        line: 54,
                        column: 30
                    },
                    end: {
                        line: 54,
                        column: 40
                    }
                },
                type: 'binary-expr',
                locations: [{
                    start: {
                        line: 54,
                        column: 30
                    },
                    end: {
                        line: 54,
                        column: 35
                    }
                }, {
                    start: {
                        line: 54,
                        column: 39
                    },
                    end: {
                        line: 54,
                        column: 40
                    }
                }],
                line: 54
            }
        },
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0,
            '4': 0,
            '5': 0,
            '6': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        b: {
            '0': [0, 0],
            '1': [0, 0]
        },
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_uzk6x96ju.s[0]++;
(function () {
    'use strict';

    cov_uzk6x96ju.f[0]++;
    cov_uzk6x96ju.s[1]++;
    angular.module('app').factory('ProjectsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_uzk6x96ju.f[1]++;
        cov_uzk6x96ju.s[2]++;


        return restmod.model('/projects').mix('MixinContainable', {
            $extend: {
                Collection: {
                    $limit: 1000
                }
            },
            $config: {
                contains: {
                    tasks: {
                        type: 'hasMany',
                        table: 'TasksTable',
                        foreignKey: 'project'
                    },
                    statistics: {
                        type: 'hasMany',
                        table: 'StatisticsTable',
                        foreignKey: 'project'
                    },
                    stories: {
                        type: 'hasMany',
                        table: 'StoriesTable',
                        foreignKey: 'project'
                    },
                    proposals: {
                        type: 'hasMany',
                        table: 'ProposalsTable',
                        foreignKey: 'project'
                    },
                    reports: {
                        type: 'hasMany',
                        table: 'ProjectReportsTable',
                        foreignKey: 'project'
                    }
                }
            },
            totalDuration: {
                decode: function decode(value) {
                    cov_uzk6x96ju.f[2]++;

                    var num = (cov_uzk6x96ju.s[3]++, (cov_uzk6x96ju.b[0][0]++, value) || (cov_uzk6x96ju.b[0][1]++, 0));
                    cov_uzk6x96ju.s[4]++;
                    return num;
                }
            },
            totalEta: {
                decode: function decode(value) {
                    cov_uzk6x96ju.f[3]++;

                    var num = (cov_uzk6x96ju.s[5]++, (cov_uzk6x96ju.b[1][0]++, value) || (cov_uzk6x96ju.b[1][1]++, 0));
                    cov_uzk6x96ju.s[6]++;
                    return num;
                }
            }
        });
    }
})();